import React from "react";
import { AddOrEditMachineProxyPage } from "./AddOrEditMachineProxyPage";
interface MachineProxyPageProps {
    proxyId: string;
}
export function MachineProxyPage({ proxyId }: MachineProxyPageProps) {
    return <AddOrEditMachineProxyPage proxyId={proxyId}/>;
}
